import { Card, Box, Typography, useTheme } from "@mui/material";

const StatCard = ({ title, value, icon, iconBg }) => {
  const theme = useTheme();

  return (
    <Card
      sx={{
        px: 3,
        py: 3,
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        backgroundColor: theme.palette.background.paper,
        border: `1px solid ${theme.palette.divider}`,
        boxShadow:
          theme.palette.mode === "dark"
            ? "0px 1px 3px rgba(0, 0, 0, 0.3)"
            : "0px 1px 3px rgba(0, 0, 0, 0.1)",
        borderRadius: 3,
        transition: "transform 0.18s ease-out, box-shadow 0.18s ease-out, border-color 0.18s ease-out",
        cursor: "pointer",
        "&:hover": {
          transform: "translateY(-3px)",          
          boxShadow:
            theme.palette.mode === "dark"
              ? "0 10px 25px rgba(15,23,42,0.9)"
              : "0 10px 25px rgba(148,163,184,0.35)",
        },
      }}
    >
      <Box>
        <Typography
          variant="body1"
          sx={{ mb: 1, color: theme.palette.text.secondary }}
        >
          {title}
        </Typography>

        <Typography
          variant="h3"
          fontWeight={700}
          sx={{ color: theme.palette.text.primary }}
        >
          {value}
        </Typography>
      </Box>

      <Box
        sx={{
          width: 40,
          height: 40,
          borderRadius: 2,
          backgroundColor: iconBg,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          flexShrink: 0,
        }}
      >
        {icon}
      </Box>
    </Card>
  );
};

export default StatCard;
